export const SET_AUTHENTICATION_STATUS = "SET_AUTHENTICATION_STATUS";

export const setAuthenticationStatus = isAuthenticated => {
  return {
    type: SET_AUTHENTICATION_STATUS,
    payload: isAuthenticated
  };
};
